import {
  Box,
} from "@mui/material";
import { BasicSelect } from "../../ui/dropdown";
import { TextFieldStr } from "../../ui/text-field";
import { usePlannerContext } from "../../../services/context/planner-context";
import { useUserContext } from "../../../services/context/user-context";


export const Truckparking = ({ area, nodeId }) => {
  const { setNodes } = usePlannerContext();
  const { viewOnly } = useUserContext();
  const formValues = area.building;

  const handleValueChange = (value, name) => {
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              building: {
                ...node.data.building,
                [name]: value,
              },
            },
          };
        }
        return node;
      })
    );
  };

  return (
    <Box
    sx={{
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      mt: "16px",
    }}
  >
 {/* <CollapsedBox height={380}> */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        <TextFieldStr
          label={"No. of Parking Slots"}
          unit=""
          placeholder="mandatory"
          name="numParkingSlots"
          requier={true}
          value={formValues.numParkingSlots}
          setValue={handleValueChange}
          area={area}
          shouldBeInteger={true}
          disabled={viewOnly}
        />

        <BasicSelect
          label={"Truck and Delivery Requirements"}
          unit={"t"}
          /* requier={true} remove for test admin */
          name="truckRequirement"
          placeholder="mandatory"
          value={formValues.truckRequirement}
          setValue={handleValueChange}
          options={[0, 3, 5, 7, 18, 40]}
          area={area}
          disabled={viewOnly}
        />

        <TextFieldStr
          label={"Cost per m²GFA"}
          unit="€/m²GFA"
          placeholder="optional"
          name="cost"
          value={formValues.cost}
          setValue={handleValueChange}
          area={area}
          disabled={viewOnly}
        />
      </Box>
   {/*  </CollapsedBox> */}
  </Box>
   
  );
};
